<template>
    <app-page :pageTitle="$t('options.page_title')" icon="fa-cog">
        <v-row class="pt-3 pl-3">
            <v-expansion-panels multiple focusable v-model="selectedPanel">
                <v-expansion-panel v-for="section in options" :key="section.Key">
                    <v-expansion-panel-header>{{ label(section[0].Section) }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row v-for="opt in section" :key="opt.Id">
                            <v-combobox v-if="opt.AllowedValues" :items="opt.AllowedValues" :label="label(opt.Id)" v-model="opt.Value" />
                            <v-text-field
                                v-else-if="opt.ValueType.startsWith('System.Int32')"
                                :label="label(opt.Id)"
                                v-model="opt.Value"
                                type="number"
                                :min="opt.MinValue"
                                :max="opt.MaxValue"
                            />
                            <v-text-field
                                v-else-if="opt.ValueType.startsWith('System.String')"
                                :label="label(opt.Id)"
                                v-model="opt.Value"
                                :min="opt.MinValue"
                                :max="opt.MaxValue"
                            />
                            <v-checkbox v-else-if="opt.ValueType.startsWith('System.Boolean')" v-model="opt.Value" :label="label(opt.Id)" />
                            <!-- <pre v-else v-text="opt" /> -->
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>

        <v-row class="pl-3">
            <v-col class="ml-0 pl-0">
                <v-btn color="success" class="my-1 mr-1" @click="onSaveClick">{{ $t("common.save") }}</v-btn>
                <v-btn color="warning" class="ma-1" @click="onRefreshClick">{{ $t("common.refresh") }}</v-btn>
                <v-btn color="warning" class="ma-1" @click="onReloadClick">{{ $t("options.reload_from_file") }}</v-btn>
            </v-col>
        </v-row>
    </app-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as a from "@/store/modules/OptionsModule/actions";
import _ from "lodash";

export default {
    data() {
        return {
            selectedPanel: [0],
            options: {},
        };
    },
    computed: {
        ...mapGetters(["optionsTree"]),
    },
    watch: {
        optionsTree(newVal) {
            "optionsTree watcher called";
            this.options = newVal;
        },
    },
    methods: {
        ...mapActions([a.FETCH_OPTIONS, a.SAVE_OPTIONS, a.RELOAD_FROM_FILE]),
        onSaveClick() {
            this[a.SAVE_OPTIONS](this.options);
        },
        onRefreshClick() {
            this.fetchOptionsToLocal();
        },
        onReloadClick() {
            this[a.RELOAD_FROM_FILE]();
        },
        async fetchOptionsToLocal() {
            await this[a.FETCH_OPTIONS]();
            this.optionsTree.OPTIONS.forEach((opt) => {
                if (opt.Value == null) opt.Value = opt.DefaultValue;
            });
        },
        label(optionId) {
            if (optionId == "language") optionId = "defaultLanguage";
            return this.$t("options." + _.snakeCase(optionId));
        },
    },
    created() {
        this.fetchOptionsToLocal();
    },
};
</script>
